enum PlanPropertyKeys {
  CURATED_DEAL_ID = 'curated-deal-id',
  DEAL_ID = 'deal-id',
  DEAL_ID_SSP = 'deal-id-ssp',
  DEAL_IDS = 'deal-ids',
  DEAL_IDS_BY_MEDIAOWNER = 'deal-ids-by-mediaowner',
  FROM_CURATED_DEAL = 'from-curated-deal',
  MIN_BID_CPM = 'min_bid_cpm',
}

export default PlanPropertyKeys;
